var React = require('react');

function ChevronDown (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Combined Shape"),React.createElement("g",{"id":"Home-/-Main","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round","key":1},React.createElement("g",{"id":"Shoutout---Home---Mobile","transform":"translate(-190.000000, -750.000000)","stroke":"#5B00DB","strokeWidth":"4"},React.createElement("g",{"id":"Welcome-Banner","transform":"translate(0.000000, 167.000000)"},React.createElement("path",{"d":"M192.5,585.5 L207.5,601.5 M222.5,585.5 L207.5,601.5","id":"Combined-Shape"}))))]);
}

ChevronDown.defaultProps = {"width":"35px","height":"21px","viewBox":"0 0 35 21","version":"1.1"};

module.exports = ChevronDown;

ChevronDown.default = ChevronDown;
